export default __webpack_public_path__ + "static/media/DayCloud.151521b5.mp4";